import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IMessageModel, MessageSeverity } from "../message-panel.models";
import { NgClass } from "@angular/common";
import { TextExpanderComponent } from "../../text-expander/text-expander.component";

@Component({
    selector: "rask-message-panel-item",
    templateUrl: "./message-panel-item.component.html",
    styleUrls: ["./message-panel-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        TextExpanderComponent
    ]
})
export class MessagePanelItemComponent {
    @Input() maxNumOfRows: number;
    @Input() item: IMessageModel;
    anchorText = "Gå till fältet";
    @Output() anchorClick = new EventEmitter<IMessageModel>();

    get iconClass(): string {
        switch (this.item.severity) {
            case MessageSeverity.Critical:
                return "fa-exclamation-triangle error";
            case MessageSeverity.Error:
                return "fa-exclamation-circle error";
            case MessageSeverity.Warning:
                return "fa-exclamation-square warning";
            case MessageSeverity.Update:
                return "fa-sync";
            case MessageSeverity.Info:
                return "fa-info-circle";
            default:
                throw new Error(
                    `No implementation for provided MessageSeverity: ${this.item.severity}.`
                );
        }
    }

    get anchorClass(): string {
        switch (this.item.severity) {
            case MessageSeverity.Critical:
                return "error";
            case MessageSeverity.Error:
                return "error";
            case MessageSeverity.Warning:
                return "warning";
            default:
                return "";
        }
    }

    get hasAnchor(): boolean {
        if (ObjectUtils.stringHasValue(this.item.anchorText)) {
            this.anchorText = this.item.anchorText;
        }
        return ObjectUtils.stringHasValue(this.item.anchor);
    }

    anchorClicked(): void {
        this.anchorClick.emit(this.item);
    }
}
